import {ResultSet} from "@recoinsights/types";
import {
    Metrics,
    EmployeeSatisfaction,
    resolveMetricResults
} from "@recoinsights/metrics";
import {Column} from "@ant-design/charts";
import CompanyInterface from "../../../../shared/types/Company";
import {getCompany, sortResultsByCompany} from "../../helpers/portfolio";

enum Labels {
    Year = "Year",
    Score = "Score",
    Company = "Company",
}

interface Props {
    companies: CompanyInterface[];
    results: ResultSet[];
}

function PortfolioResultsEmployeeSatisfactionChart({ companies, results }: Props) {
    const data: { [Labels.Year]: number, [Labels.Score]?: number, [Labels.Company]: string }[] = [];

    results.sort(sortResultsByCompany(companies)).forEach((result) => {
        const metric = resolveMetricResults(Metrics.EmployeeSatisfaction, result) as EmployeeSatisfaction;

        data.push({
            [Labels.Year]: result.year,
            [Labels.Score]: metric.score !== undefined ? Math.round(metric.score) : undefined,
            [Labels.Company]: getCompany(companies, result.company)?.name ?? '-',
        });
    });

    return (
        <Column
            data={data}
            isGroup={true}
            xField={Labels.Year}
            yField={Labels.Score}
            seriesField={Labels.Company}
            legend={{ position: "right-bottom", maxWidthRatio: 0.33, padding: [0, 0, 0, 30], itemHeight: 10, }}
            height={400} />
    );
}

export default PortfolioResultsEmployeeSatisfactionChart;
